module.exports = __webpack_public_path__ + "static/media/slide_3.0b131d36.jpg";